<script>
    import RadioSubcategory from "./questionnaire-components/RadioSubcategory.svelte";
    import InputField from "../ui_elements/InputField.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import { onMount } from 'svelte';
    import PageBox from "../layouts/PageBox.svelte";
    import Button from "../ui_elements/Button.svelte";
    import { getData, post, getQuestionnaire } from "../utility.js";
    import { push } from "svelte-spa-router";
    import { tick } from 'svelte';

    let feedbackAnswers = {};
    let categoryName = "Feedback";

    let subcategories;
    let message; 

    onMount(async () => {
        // let data = await getData(`get-questionnaire/`);
        let data = await getQuestionnaire();

        subcategories = data['categories'].find(category => category.category_name === 'Feedback')['subcategories'];

        data = await getData('get-feedback/');
        feedbackAnswers = data.feedback_answers || {};
        console.log(feedbackAnswers);

        if (Object.keys(feedbackAnswers).length === 0) {
            subcategories.filter(subcategory => subcategory.subcategory_name != 'Feedback Textfragen').forEach(subcategory => {
                feedbackAnswers[subcategory.subcategory_id] = {};
            });
        }
    });

    const submitAnswers = async (event) => {
        event.preventDefault();
        try {
            const data = await post('submit-feedback/', { feedbackAnswers });
            console.log(data);
            message = "Dein Feedback wurde erfolgreich gespeichert!";
            await tick();
            setTimeout(() => {
                message = "";
            }, 2000);

        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };

    const submitAll = async (event) => {
        submitAnswers(event);
        push('/results?m=feedback');
    }

    function handleAnswerChange(event) {
        // feedbackAnswers[event.detail.subcategoryID] = event.detail.answers;
    }


</script>

{#if message}
    <div class="fixed top-50 w-full bg-accent2-background border border-accent2-border text-accent2-text p-4 z-50">
        {message}
    </div>
{/if}


<PageBox pageTitle="Dein Feedback">   
        
    <ContentBox>
        <p>Vielen Dank für deine Teilnahme an der Berufsberatung! Wir freuen uns sehr, falls du uns dein Feedback zum Fragebogen und zur Website mitteilen willst. </p>

        <br>
        
        <p>Alle Feedback-Fragen sind freiwillig. Falls du zu einer Frage keine Angaben machen willst oder dir nichts einfällt, kannst du diese Frage unbeantwortet lassen. Wir freuen uns über dein Feedback!</p>
    </ContentBox>    

    {#if subcategories}

        {#each subcategories.filter(subcategory => subcategory.questions[0].question_type_id == "FEEDBACK_RATING") as radioSubcategory}
            <ContentBox>
                <div class="text-secondary-text font-bold text-lg">{radioSubcategory.subcategory_name}</div>
                <RadioSubcategory questions={radioSubcategory.questions} subcategoryID={radioSubcategory.subcategory_id} {categoryName} on:answerChange={handleAnswerChange} bind:answers={feedbackAnswers[radioSubcategory.subcategory_id]}/>
                <Button on:click={submitAnswers} className="mt-2 ml-auto" variant="submit">Antworten speichern</Button>
            </ContentBox>
        {/each}

        <ContentBox>
            {#each subcategories.find(subcategory => subcategory.subcategory_name == "Feedback Textfragen").questions as textQuestion}
                <InputField bind:value={feedbackAnswers[textQuestion.question_id]} id={textQuestion.question_id} label={textQuestion.question_text} labelDisplay="" />         
            {/each}
        </ContentBox>

        <div class="flex mx-4 mb-2 justify-between w-2/3" style="min-width: 600px">
            <Button on:click={() => push('/results')}>Zurück zu deinen Ergebnissen</Button>
            <Button on:click={submitAll} variant="submit">Feedback abschicken</Button>
        </div>

    {/if}
</PageBox>

